import React from 'react';
import { observer } from 'mobx-react';
import {
  Card,
  CardBody,
  CardTitle,
  CodeBlock,
  CodeBlockCode,
} from '@patternfly/react-core';
import type { LabDriverComponentProps } from '../types';

const DefaultLabComponent: React.FC<LabDriverComponentProps> = ({
  labComponent,
}) => (
  <Card>
    <CardTitle>Default Component</CardTitle>
    <CardBody>
      <CodeBlock>
        <CodeBlockCode>{JSON.stringify(labComponent, null, 2)}</CodeBlockCode>
      </CodeBlock>
    </CardBody>
  </Card>
);

export default observer(DefaultLabComponent);
